import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../../apiCalls/rtkBaseQuery';

export const aboutUsApi = createApi({
    baseQuery,
    reducerPath: 'aboutUsApi',
    endpoints: (builder) => ({
        getAboutUsList: builder.query({
            query: () => ({
                url: '/site/about',
                method: 'GET',
            }),
        }),
        updateAboutUsList: builder.mutation({
            query: (data) => ({
                url: '/admin/site/about',
                method: 'POST',
                body: data,
            }),
        }),
        uploadAboutUsFile: builder.mutation({
            query: (formData) => ({
                url: '/admin/site/upload',
                method: 'POST',
                body: formData,
            }),
        }),
    }),
});

export const {
    useGetAboutUsListQuery,
    useUpdateAboutUsListMutation,
    useUploadAboutUsFileMutation,
} = aboutUsApi;
